import Master from "./Master";
import React, { useState } from "react";

function Contact(){

const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = {
    name: e.target.name.value,
    email: e.target.email.value,
    phone: e.target.phone.value,
    subject: e.target.subject.value,
    msg: e.target.msg.value,
  };

  try {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    const data = await res.json();
    alert(data.message);


  } catch (err) {
    console.error(err);
    alert("Something went wrong. Please try again.");
  }
};
    return(
        <Master>

    {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque">Contact<span> Us</span></h1>
						<nav className="wow fadeInUp">
							<ol className="breadcrumb">
								<li className="breadcrumb-item"><a href="./">home</a></li>
								<li className="breadcrumb-item active" aria-current="page">contact us</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

    {/* Page Contact Start */}
     <div className="page-contact">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="contact-us-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                            <h3 className="wow fadeInUp">contact info</h3>
                            <h2 className="text-anime-style-2" data-cursor="-opaque"><span>Connecting</span> Near & Far </h2>
                            <p className="wow fadeInUp" data-wow-delay="0.25s">For urgent dental care or booking an appointment, reach out to our office or visit our clinic today.</p>
                        </div>
                        {/* Section Title End */}

                        {/* Contact US Info Start */}
                        <div className="contact-us-info">
                            <div className="row">
                                <div className="col-md-6">
                                    {/* Contact US Item Start */}
                                    <div className="contact-us-item wow fadeInUp">
                                        {/* Icon Box Start */}
                                        <div className="icon-box">
                                            <img src="images/icon-location.svg" alt="" />
                                        </div>
                                        {/* Icon Box End */}

                                        {/* Contact Us Content Start */}
                                        <div className="contact-info-content">
                                            <h3>visit us on</h3>
                                            <p>Karad-Tasgaon Road, Palus</p>
                                        </div>
                                        {/* Contact Us Content End */}
                                    </div>
                                    {/* Contact Us Item End */}
                                </div>

                                <div className="col-md-6">
                                    {/* Contact US Item Start */}
                                    <div className="contact-us-item wow fadeInUp" data-wow-delay="0.25s">
                                    {/* Icon Box Start */}
                                    <div className="icon-box">
                                        <img src="images/icon-phone.svg" alt="" />
                                    </div>
                                    {/* Icon Box End */}

                                    {/* Contact Us Content Start */}
                                    <div className="contact-info-content">
                                        <h3>contact us</h3>
                                        <p><a href="tel:+917887919983"> 7887919983</a></p>
                                    </div>
                                    {/* Contact Us Content End */}
                                    </div>
                                {/* Contact Us Item End */}
                                </div>

                                <div className="col-md-6">
                                    {/* Contact US Item Start */}
                                    <div className="contact-us-item wow fadeInUp" data-wow-delay="0.5s">
                                        {/* Icon Box Start */}
                                        <div className="icon-box">
                                            <img src="images/icon-clock.svg" alt="" />
                                        </div>
                                        {/* Icon Box End */}

                                        {/* Contact Us Content Start */}
                                        <div className="contact-info-content">
                                            <h3>working hours</h3>
                                            <p>Mon to Sat : 11:00AM To 2:00PM</p>
                                            <p>: 5:00PM To 7:00PM</p>
                                        </div>
                                        {/* Contact Us Content End */}
                                    </div>
                                    {/* Contact Us Item End */}
                                </div>

                                <div className="col-md-6">
                                    {/* Contact US Item Start */}
                                    <div className="contact-us-item wow fadeInUp" data-wow-delay="0.75s">
                                        {/* Icon Box Start */}
                                        <div className="icon-box">
                                            <img src="images/icon-mail.svg" alt="" />
                                        </div>
                                        {/* Icon Box End */}

                                        {/* Contact Us Content Start */}
                                        <div className="contact-info-content">
                                            <h3>email us</h3>
                                            <p><a href="mailto:citydentalclinicpalus@gmail.com?subject=Dental Appointment Inquiry">citydentalclinicpalus@gmail.com</a></p>
                                        </div>
                                        {/* Contact Us Content End */}
                                    </div>
                                    {/* Contact Us Item End */}
                                </div>
                            </div>
                        </div>
                        {/* Contact US Info End */}
                    </div>
                </div>
                <div className="col-lg-6">
                    {/* Google Map Start */}
                    <div className="google-map">
                        {/* Google Map Iframe Start */}
                        <div className="google-map-iframe">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d122034.15960517613!2d74.27667158906245!3d17.09379608409341!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc16dfdfcf5a5bb%3A0x224656ff3e8aafb7!2sCity%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1781329146839!5m2!1sen!2sin" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>                        {/* Google Map Iframe End */}
                        </div>
                        {/* Google Map Iframe End */}
                    </div>
                    {/* Google Map End */}
                </div>
            </div>
        </div>
     </div>
    {/* Page Contact End */}

    {/* Contact Form Start */}
	<div className="contact-us-form">
		<div className="container">
			<div className="row align-items-center">
				<div className="col-lg-6">
					{/* Contact Us Image Start */}
					 <div className="contact-us-img">
						<figure className="reveal image-anime">
							<img src="images/contact-us-img.jpg" alt="" />
						</figure>
					 </div>
					{/* Contact Us Image End */}
				</div>
				<div className="col-lg-6">
					<div className="contact-form">
						{/* Section Title Start */}
						<div className="section-title">
                            <h3 className="wow fadeInUp">contact us</h3>
                            <h2 className="text-anime-style-2" data-cursor="-opaque"><span>Get</span> In Touch With Us</h2>
                        </div>
                        {/* Section Title End */}

<form onSubmit={handleSubmit} id="contactForm" action="#" method="POST" data-toggle="validator" className="wow fadeInUp" data-wow-delay="0.25s">
  <div className="row">
    
    <div className="form-group col-md-6 mb-4">
      <input type="text" name="name" className="form-control" placeholder="Enter Name" required />
    </div>

    <div className="form-group col-md-6 mb-4">
      <input type="email" name="email" className="form-control" placeholder="Enter Email" required />
    </div>

    <div className="form-group col-md-6 mb-4">
      <input type="text" name="phone" className="form-control" placeholder="Phone Number" required />
    </div>

    <div className="form-group col-md-6 mb-4">
      <input type="text" name="subject" className="form-control" placeholder="Subject" required />
    </div>

    <div className="form-group col-md-12 mb-5">
      <textarea name="msg" className="form-control" rows="5" placeholder="Your Message" required></textarea>
    </div>

    <div className="col-md-12">
      <button type="submit" className="btn-default">
        send message
      </button>
    </div>

  </div>
</form>
					</div>
				</div>
			</div>
</div>
    </div>
	{/* Contact Form End */}
        </Master>
    );
}

export default Contact;